type PlaceholderValues<T> = Partial<{
  [K in keyof T]: T[K] extends Date | null ? Date : string;
}>;

function mergePlaceholders<T>(
  targetData: { [K in keyof T]: T[K] },
  placeholders: PlaceholderValues<T>,
  nextPlaceholders: PlaceholderValues<T>,
): Partial<T> {
  const result = {} as { [K in keyof T]: T[K] };

  for (const key of Object.keys(nextPlaceholders) as (keyof T)[]) {
    const targetValue = String(targetData[key] ?? '');
    const currentPlaceholder = String(placeholders[key] ?? '');

    if (targetValue === currentPlaceholder) {
      result[key] = nextPlaceholders[key] as T[keyof T];
    }
  }

  return result;
}

function stripSuggestedValues<T>(
  targetData: { [K in keyof T]: T[K] },
  placeholders: PlaceholderValues<T>,
  nonStrippableKeys: (keyof T)[] = [],
): Partial<T> {
  const result = {} as { [K in keyof T]: T[K] };

  for (const key of Object.keys(placeholders) as (keyof T)[]) {
    if (nonStrippableKeys.includes(key)) {
      continue;
    }
    const targetValue = targetData[key];

    if (String(targetValue ?? '') === String(placeholders[key] ?? '')) {
      result[key] = (targetValue instanceof Date ? null : '') as T[keyof T];
    }
  }

  return result;
}

export { mergePlaceholders, stripSuggestedValues };
